import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import gibletLogo from '@/assets/giblet-logo.png';

const issueTypes = [
  { id: 'ip-violation', name: 'Intellectual Property Violation', description: 'Content uses proprietary material without authorization or proper licensing' },
  { id: 'factual-inaccuracy', name: 'Factual Inaccuracy / Outdated Information', description: 'Content contains incorrect facts or references superseded standards' },
  { id: 'security-risk', name: 'Security Risk / Data Exposure', description: 'Content reveals sensitive data, credentials, or creates security vulnerabilities' },
  { id: 'ethical-concerns', name: 'Ethical Concerns / Bias', description: 'Content contains discriminatory, biased, or ethically problematic material' },
  { id: 'duplicate-content', name: 'Duplicate / Redundant Content', description: 'Content substantially duplicates an existing KB without adding value' },
  { id: 'privacy-violation', name: 'Privacy Violation', description: 'Content exposes personal information without consent (PII, HIPAA, etc.)' },
  { id: 'regulatory-noncompliance', name: 'Regulatory Non-Compliance', description: 'Content conflicts with current regulations, codes, or legal requirements' },
  { id: 'plagiarism', name: 'Plagiarism / Attribution Failure', description: 'Content copied without attribution or misrepresents authorship' },
];

export default function DemoCallForDestructionIssueType() {
  const navigate = useNavigate();
  const [selectedType, setSelectedType] = useState('');

  const handleNext = () => {
    if (selectedType) {
      const issue = issueTypes.find(t => t.id === selectedType);
      navigate('/demo-call-for-destruction/evidence', {
        state: { issueType: selectedType, issueTypeName: issue?.name }
      });
    }
  };

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-6">
      <div className="max-w-3xl w-full space-y-8">
        <div className="flex justify-center mb-8">
          <img src={gibletLogo} alt="Giblet Logo" className="h-16 w-auto" />
        </div>

        <div className="text-center space-y-4">
          <h1 className="text-3xl font-bold text-foreground">Issue Classification</h1>
          <p className="text-lg text-muted-foreground">
            What type of issue are you reporting?
          </p>
        </div>

        <div className="bg-card rounded-lg p-8 shadow-lg space-y-2 max-h-[500px] overflow-y-auto">
          <RadioGroup value={selectedType} onValueChange={setSelectedType}>
            {issueTypes.map((type) => (
              <div key={type.id} className="flex items-start space-x-3 p-3 rounded-lg hover:bg-accent/50 transition-colors">
                <RadioGroupItem value={type.id} id={type.id} className="mt-1" />
                <Label htmlFor={type.id} className="flex-1 cursor-pointer">
                  <div className="font-semibold text-foreground">{type.name}</div>
                  <div className="text-sm text-muted-foreground mt-0.5">{type.description}</div>
                </Label>
              </div>
            ))}
          </RadioGroup>
        </div>

        <div className="flex justify-center gap-4">
          <Button variant="outline" onClick={() => navigate('/demo-call-for-destruction')} className="min-w-[120px]">
            Back
          </Button>
          <Button onClick={handleNext} disabled={!selectedType} className="min-w-[120px]">
            Next
          </Button>
        </div>
      </div>
    </div>
  );
}
